import React from 'react';
import { Input } from './Input';
import { Select } from './Select';
interface DateTimePickerProps {
  label?: string;
  dateValue: string;
  timeValue: string;
  timezoneValue: string;
  onDateChange: (val: string) => void;
  onTimeChange: (val: string) => void;
  onTimezoneChange: (val: string) => void;
  error?: string;
}
export function DateTimePicker({
  label,
  dateValue,
  timeValue,
  timezoneValue,
  onDateChange,
  onTimeChange,
  onTimezoneChange,
  error
}: DateTimePickerProps) {
  return <div className="space-y-2" data-id="element-260">
      {label && <label className="block text-sm font-medium text-gray-700" data-id="element-261">
          {label}
        </label>}
      <div className="grid grid-cols-12 gap-2" data-id="element-262">
        <div className="col-span-5" data-id="element-263">
          <Input type="date" value={dateValue} onChange={e => onDateChange(e.target.value)} error={error ? ' ' : undefined} // Just trigger red border
        data-id="element-264" />
        </div>
        <div className="col-span-3" data-id="element-265">
          <Input type="time" value={timeValue} onChange={e => onTimeChange(e.target.value)} error={error ? ' ' : undefined} data-id="element-266" />
        </div>
        <div className="col-span-4" data-id="element-267">
          <Select value={timezoneValue} onChange={e => onTimezoneChange(e.target.value)} options={[{
          value: 'America/New_York',
          label: 'ET'
        }, {
          value: 'America/Chicago',
          label: 'CT'
        }, {
          value: 'America/Denver',
          label: 'MT'
        }, {
          value: 'America/Los_Angeles',
          label: 'PT'
        }]} data-id="element-268" />
        </div>
      </div>
      {error && <p className="text-xs text-red-600" data-id="element-269">{error}</p>}
    </div>;
}